import(/* webpackMode: "eager", webpackExports: ["Capabilities"] */ "/srv/app/apps/web/components/sections/Capabilities.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CTABanner"] */ "/srv/app/apps/web/components/sections/CTABanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/srv/app/apps/web/components/sections/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Industries"] */ "/srv/app/apps/web/components/sections/Industries.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Metrics"] */ "/srv/app/apps/web/components/sections/Metrics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Process"] */ "/srv/app/apps/web/components/sections/Process.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TechStack"] */ "/srv/app/apps/web/components/sections/TechStack.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhatWeDo"] */ "/srv/app/apps/web/components/sections/WhatWeDo.tsx");
;
import(/* webpackMode: "eager" */ "/srv/app/apps/web/components/ui/Link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Reveal"] */ "/srv/app/apps/web/components/ui/Reveal.tsx");
